export default "__VITE_ASSET__vzm9Sg5H__"